import type { Conversation } from '@twilio/conversations';
import { getTwilioConversation } from 'app/services/twilio/conversation';
import { useEffect, useState } from 'react';

export default function useConversation() {
  const [conversation, setConversation] = useState<Conversation>();

  useEffect(() => {
    getTwilioConversation().then(setConversation);
  }, []);

  return conversation;
}
